import { render } from "./IconToggleButton.vue?vue&type=template&id=3aa618d0"
import script from "./IconToggleButton.vue?vue&type=script&lang=js"
export * from "./IconToggleButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/IconToggleButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3aa618d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3aa618d0', __exports__)) {
    api.reload('3aa618d0', __exports__)
  }
  
  module.hot.accept("./IconToggleButton.vue?vue&type=template&id=3aa618d0", () => {
    api.rerender('3aa618d0', render)
  })

}


export default __exports__